/**
 * this component will display the reounded corner rectangle and render the children passed to it.
 *
 * @module views/components/RoundedContainer
 * @memberof -Common
 */
import './RoundedContainer.scss';

import React from 'react';

import classNames from 'classnames';
import PropTypes from 'prop-types';


/**
 * Represents a RoundedContainerProps Component
 * @param {RoundedContainerProps} props
 * @returns RoundedContainer
 */
const RoundedContainer = ( props ) => {
  const { children, layout = 'vertical' } = props;
  if( ! children ){
    return null;
  }
  return (
    <div className={ classNames( 'RoundedContainerGroup', {
      ...( { [`RoundedContainerGroup--${layout}`]: layout } )
    } ) }
    >
      { React.Children.map( children, ( child ) => (
        <div className='RoundedContainer'>
          { child }
        </div>
      ) ) }
    </div>
  );
};

/**
  * Property type definitions
  * @typedef RoundedContainerProps
  * @type {object}
  * @property {node} children - Child node(s) that can be nested inside component
  * @property {string} layout - Aligns the children in row or column style
  */
export const propTypes = {
  children: PropTypes.node,
  layout: PropTypes.string
};
RoundedContainer.prototype = propTypes;
export default RoundedContainer;